// extracted by mini-css-extract-plugin
var _1 = "LbYJw";
var _2 = "w1T8I";
var _3 = "zO5At";
export { _1 as "buttonsWrapper", _2 as "savedIcon", _3 as "savedMessage" }
